export default __webpack_public_path__ + "static/media/DreamJobs2_08.ce2bd68f.png";